import moment from 'moment';
import React, { VFC } from 'react';

interface IProps {
    hours: moment.Moment;
}

const HoursCell: VFC<IProps> = ({ hours }) => {
    return <td>{hours.format('HH:mm')}</td>;
};

export default HoursCell;
